import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface AuditRow {
  id: number;
  tier: "haiku" | "sonnet";
  pairId: string;
  firmId: string;
  claudeAction: string;
  complianceStatus: string | null;
  reason: string;
  costUsd: number | null;
  createdAt: number;
}

export function AdminAuditPage() {
  const { data } = useQuery({
    queryKey: ["admin", "audit", "global"],
    queryFn: () => api.get<{ rows: AuditRow[] }>("/api/audit?limit=100"),
    refetchInterval: 10_000,
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Audit (global)</h1>
      <p className="text-xs text-muted-foreground">
        Full decision feed across all pairs and firms. Click a row to open the
        raw prompt + response (TODO — wire to /api/audit/:id).
      </p>
      <div className="pfh-card overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="pfh-heading text-left">
              <th className="py-2">#</th>
              <th>Tier</th>
              <th>Pair</th>
              <th>Firm</th>
              <th>Action</th>
              <th>Status</th>
              <th className="text-right">Cost</th>
              <th>When</th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {data?.rows.map((r) => (
              <tr key={r.id} className="border-t border-border/60 hover:bg-muted/50">
                <td className="py-2 text-muted-foreground">{r.id}</td>
                <td>{r.tier}</td>
                <td>{r.pairId}</td>
                <td>{r.firmId}</td>
                <td>{r.claudeAction}</td>
                <td
                  className={
                    r.complianceStatus === "violation"
                      ? "text-destructive"
                      : r.complianceStatus === "warning"
                        ? "text-yellow-400"
                        : r.complianceStatus == null
                          ? "text-muted-foreground"
                          : r.complianceStatus === "ok"
                            ? "text-green-400"
                            : "text-muted-foreground"
                  }
                >
                  {r.complianceStatus ?? "—"}
                </td>
                <td className="text-right">${r.costUsd?.toFixed(4) ?? "—"}</td>
                <td className="text-muted-foreground">
                  {new Date(r.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
